<script setup lang="ts">
import { Form } from '@/shared/ui/Form'
import { Stack } from '@/shared/ui/Stack'
import {
  CancelButton,
  FormActions,
  SaveButton
} from '@/shared/ui/ActionButtons'

/**
 * The inside of a filter panel: the fields in the default slot, and a Reset / Apply footer
 * pinned bottom-right however many fields there are. `@apply` and `@reset` are what
 * `useFilterForm`'s two handlers bind to.
 *
 * The panel writes its own field grid in the slot and **no spacing at all** — the gap
 * between field rows belongs to this shell, so that every filter panel in the app is
 * spaced alike.
 */
withDefaults(
  defineProps<{
    applyText?: string
    resetText?: string
  }>(),
  {
    applyText: 'Apply',
    resetText: 'Reset'
  }
)

const emit = defineEmits<{
  (e: 'apply'): void
  (e: 'reset'): void
}>()
</script>

<template>
  <Form label-position="top" compact>
    <Stack :gap="8">
      <slot />
    </Stack>

    <FormActions>
      <CancelButton native-type="button" @click="emit('reset')">
        {{ resetText }}
      </CancelButton>
      <SaveButton native-type="button" @click="emit('apply')">
        {{ applyText }}
      </SaveButton>
    </FormActions>
  </Form>
</template>
